module.exports = __webpack_public_path__ + "img/Eval-PED1.d02e2baa.jpg";